import { render, staticRenderFns } from "./transferProject.vue?vue&type=template&id=78b35f64&scoped=true&"
import script from "./transferProject.vue?vue&type=script&lang=js&"
export * from "./transferProject.vue?vue&type=script&lang=js&"
import style0 from "./transferProject.vue?vue&type=style&index=0&id=78b35f64&lang=scss&scoped=true&"
import style1 from "./transferProject.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b35f64",
  null
  
)

export default component.exports